import React, { useContext } from "react"
import { makeStyles } from "@material-ui/core/styles"
import Accordion from "@material-ui/core/Accordion"
import AccordionSummary from "@material-ui/core/AccordionSummary"
import AccordionDetails from "@material-ui/core/AccordionDetails"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import InstructionsContext from "./shop/context/instructionsContext"

import itemHealthRefundDetails from "../../data/itemHealthRefundDetails.json"

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    fontSize: "2rem",
  },
  accordian: {
    border: "none",
    fontSize: "2rem",
    boxShadow: "none",
  },
  heading: {
    fontWeight: "bold",
  },
}))

export default function SimpleAccordion() {
  const classes = useStyles()

  const value = useContext(InstructionsContext)

  const { healthDetails, moneyBackGuarantee } = itemHealthRefundDetails

  return (
    <div className={classes.root}>
      <Accordion className={classes.accordian}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.accordian}
        >
          <b>Instructions</b>
        </AccordionSummary>
        <AccordionDetails>
          {value.productType === "product" ? value.instructions : ""}

          {value.productType === "premadeBox" ? (
            <ul>
              {value.supplementsInTheBox.map((item, index) => {
                return (
                  <li key={index}>
                    <u>{item.name}:</u> {item.instructions}
                  </li>
                )
              })}
            </ul>
          ) : (
            ""
          )}
        </AccordionDetails>
      </Accordion>

      <Accordion className={classes.accordian}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <b>Ingredients</b>
        </AccordionSummary>
        <AccordionDetails>
          {value.productType === "product" ? value.ingredients : ""}

          {value.productType === "premadeBox" ? (
            <ul>
              {value.supplementsInTheBox.map((item, index) => {
                return (
                  <li key={index}>
                    <u>{item.name}:</u> {item.ingredientAndDosage}
                  </li>
                )
              })}
            </ul>
          ) : (
            ""
          )}
        </AccordionDetails>
      </Accordion>

      <Accordion className={classes.accordian}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <b>Health and Safety</b>
        </AccordionSummary>
        <AccordionDetails>
          <div dangerouslySetInnerHTML={{ __html: healthDetails }} />
        </AccordionDetails>
      </Accordion>

      <Accordion className={classes.accordian}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <b>Money Back Guarantee</b>
        </AccordionSummary>
        <AccordionDetails>
          <div dangerouslySetInnerHTML={{ __html: moneyBackGuarantee }} />
        </AccordionDetails>
      </Accordion>
    </div>
  )
}
